import ShopConfig from './ShopConfig';

export default ShopConfig; 